export const ROW_SIZE_PIXELS = 36;
export const LIST_MAX_HEIGHT_PIXELS = 200;
export const OVERSCAN_COUNT = 5;
export const SIGN_WIDTH_PIXELS = 9;
export const MIN_LIST_WIDTH_PIXELS = 200;
//# sourceMappingURL=MenuContent.constants.js.map